import styled from "@emotion/styled";

export const StyledWrapper = styled.div<{
  $backgroundColor?: string;
  $bottomBorderColor?: string;
  $hasOnClick?: boolean;
}>`
  display: grid;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing["2"]};
  flex-shrink: 0;

  background-color: ${({ theme, $backgroundColor }) =>
    $backgroundColor ?? theme.colors.surface.paneHeader};

  align-items: center;
  padding: ${({ $hasOnClick, theme }) =>
    $hasOnClick
      ? `${theme.spacing["3"]} ${theme.spacing["5"]}`
      : `0 ${theme.spacing["3"]} 0 ${theme.spacing["5"]}`};
  min-height: ${({ theme }) => theme.spacing["10"]};
  width: 100%;

  border-bottom: ${({ $bottomBorderColor, theme }) =>
    `1px solid ${$bottomBorderColor ?? theme.colors.border.onAccent}`};

  border-radius: ${({ theme }) => `0 ${theme.borderRadius.xlarge} 0 0`};

  ${({ $hasOnClick, theme }) =>
    $hasOnClick &&
    `
    border-left: none;
    border-right: none;
    border-top: none;
    text-align: left;
    font: inherit;
    cursor: pointer;
    transition:
      border-color 0.16s ease,
      background-color 0.08s ease;

    &:disabled {
      cursor: default;
      opacity: 1;
    }

    &:focus-visible {
      outline: 2px solid ${theme.colors.border.emphasis};
      outline-offset: 2px;
    }
  `}
`;
